import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  appBarContainer: {
    display: "flex",
  },
  toolbarBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "1200px",
    paddingLeft: 20,
    paddingRight: 30,
  },
  header: {
    height: 64,
    boxShadow: "none",
    backgroundColor: theme.palette.events.grayShade1,
    color: theme.palette.text.primary,
  },
  logo: {
    position: "absolute",
    left: 33,
    width: 40,
    height: 40,
    padding: 0,
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      marginLeft: 0,
      left: 10,
    },
  },
  titleContainer: {
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    lineHeight: "22px",
    "&:not($noTitlePadding)": {
      paddingLeft: "2rem",
    },
    [theme.breakpoints.only("md")]: {
      paddingLeft: "2rem",
    },
  },
  rightAdornment: {
    display: "flex",
    alignItems: "center",
    height: "inherit",
    "& > :not(:last-child)": {
      marginRight: 30,
    },
  },
  profilePicture: {
    width: 40,
    height: 40,
  },
  companyProfile: {
    minWidth: 190,
    maxWidth: 190,
  },
  logoContainer: {
    paddingRight: 20,
  },
}));
